<template>
  <!-- Main content -->
  <section class="content">
    <div class="container-fluid" v-if="seen=='list'">
        <!-- Small boxes (Stat box) -->
        <div class="row">
        	<div class="col-md-6">
        	 	<div class="input-group  pull-right">
                	<input type="text" name="message" placeholder="Buscar ..." class="form-control" style="height:34px;margin-top: 12px;" v-model="search">
                </div>
            </div>
        	<div class="col-md-6">
        		<a class="btn btn-app pull-right bg-red" @click="nuevo()">
                  	<i class="fa fa-plus "></i> Nuevo
                </a>
        	</div>
        </div>
        <div class="row">
        	<div class="col-md-12">
          		  <div class="nav-tabs-custom">
	                <ul class="nav nav-tabs pull-left">
	                  <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="true">Activo ({{ filteredItems.length }})</a></li>
	                  <li class=""><a href="#tab_2" data-toggle="tab" aria-expanded="false">Archivo ({{ filteredEliminados.length }})</a></li>
	                </ul>
	                <div class="tab-content">
                      <div class="tab-pane active" id="tab_1">
    	                    <paginate
    	                      v-if="filteredItems.length > 0"
                              name="filteredItems"
                              :list="filteredItems"
                              :per="15"
                            >
    	                    <table class="table table-striped">
    			                  <tbody><tr>
    			                    <th>Proyecto</th>
    			                    <th>Cliente</th>
    			                    <th>Producto</th>
    			                    <th>&nbsp;</th>
    			                  </tr>
    			                  <tr v-for="item in paginated('filteredItems')" v-bind:key="item._id">
    			                    <td>{{ item.proyecto }}</td>
    			                    <td>{{ item.cliente }}</td>
    			                    <td>{{ item.producto }}</td>
    			                    <td v-if="typeof item.asset === 'undefined'">
    			                    	<button type="button" @click="cargar(item)" class="btn btn-block btn-primary btn-sm btn-edit">Editar</button>
    			                    	<i class="fas fa-times-circle" @click="remove(item)"></i>
    			                    </td>
    			                    <td v-if="typeof item.asset != 'undefined'">
    			                    	<i class="fas fa-sync"></i>&nbsp; Pendiente
    			                    </td>
    			                  </tr>
    			                </tbody>
    			             </table>
    			             </paginate>
    			             <paginate-links for="filteredItems" :async="true" class="pagination pull-right"></paginate-links>
                      </div>
                      <!-- /.tab-pane -->
                      <div class="tab-pane" id="tab_2">
                        	<paginate
    	                      v-if="filteredEliminados.length > 0"
                              name="filteredEliminados"
                              :list="filteredEliminados"
                              :per="15"
                            >
                        	<table class="table table-striped">
    			                  <tbody><tr>
    			                    <th>Proyecto</th>
    			                    <th>Cliente</th>
    			                    <th>Producto</th>
    			                    <th>&nbsp;</th>
    			                  </tr>
    			                  <tr v-for="eliminado in paginated('filteredEliminados')" v-bind:key="eliminado.id">
    			                    <td>{{ eliminado.proyecto }}</td>
    			                    <td>{{ eliminado.cliente }}</td>
    			                    <td>{{ eliminado.producto }}</td>
    			                    <td v-if="onlineState">
    			                    	<button type="button" @click="desarchivar(eliminado)" class="btn btn-block btn-primary btn-sm btn-edit" style="max-width: 84px;">Desarchivar</button>
    			                    </td>
    			                  </tr>
    			                </tbody>
    			             </table>
    			             </paginate>
    			             <paginate-links for="filteredEliminados" :async="true" class="pagination pull-right"></paginate-links>
                      </div>
                      <!-- /.tab-pane -->
                    </div>
                </div>
                <!-- /.tab-content -->
            </div>
        </div>
        <!-- /.row -->
        <!-- Main row -->
        
        <!-- /.row (main row) -->
      </div><!-- /.container-fluid -->
      <!-- form -->
      <div class="container-fluid"  v-if="seen=='form'">
  		<div class="row">
          <div class="col-md-12" v-if="seen=='form'">
        		<a class="btn btn-app pull-right bg-red" @click="cancelar()">
                  	<i class="fa fa-times "></i> Cerrar
                </a>
          </div>
    	</div>
  		<div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">Nuevo Registro</h3>
            </div>
      		<form role="form">
            <div class="box-body">
               <div class="col-md-12">
                    <div class="form-group">
                    	<label>Proyecto</label>
                        <input type="text" v-model="input.proyecto" v-validate="'required'" name="proyecto"  class="form-control">
                        <span class="help-block">{{ errors.first('proyecto') }}</span>
                    </div>
                    <div class="form-group">
                      	<label>Cliente</label>
                      	<input type="text" v-model="input.cliente" v-validate="'required'" name="cliente" class="form-control">
                      	<span class="help-block">{{ errors.first('cliente') }}</span>
                    </div>
                    <div class="form-group">
                      	<label>Producto</label>
                      	<input type="text" v-model="input.producto" v-validate="'required'" name="producto" class="form-control">
                      	<span class="help-block">{{ errors.first('producto') }}</span>
                    </div>
                    <div class="form-group">
                      	<label>Descripci&oacute;n Producto</label>
                      	<textarea v-model="input.descripcion_producto" name="descripcion_producto" class="form-control"></textarea>
                      	<span class="help-block">{{ errors.first('descripcion_producto') }}</span>
                    </div>
                    <button type="button" v-if="savebtn" @click="guardar()" class="btn btn-primary">Crear</button>
                    <button type="button" v-if="updatebtn" @click="editar(input._id)" class="btn btn-primary">Editar</button>
                    <button type="button" @click="cancelar()" class="btn btn-default">Cancelar</button>
                </div>
             </div>
             </form>
          </div>
      </div>
      <!-- end form -->
      
  </section>
  <!-- /.content -->
</template>

<script>
/* eslint-disable */
import axios from "axios";

export default {
	data () {
		return {
			items: [],
			eliminados: [],
			paginate: ['filteredItems', 'filteredEliminados'],
			seen: 'list',
			savebtn: true,
			updatebtn: false,
			input: {
				'_id': '',
				'proyecto': '',
				'producto': '',
				'cliente': '',
				'descripcion_producto': '',
				'accion': ''
			},
			token: window.localStorage.getItem('token'),
			onlineState: navigator.onLine,
			tipoItem: 'producto',
			urlAPI: 'https://data.sima-api.com/shaleproductos',
			search: ''
		}
	},
	methods: {
    	show (component) {
			this.seen = component
    	},
    	listar() {
    		this.show('list')
        },
        cancelar() {
    		this.clearForm
        	this.show('list')
        },
    	nuevo() {
    		this.savebtn = true
			this.updatebtn = false
			this.show('form')
    	},
    	guardar() {
    		var vm = this
    		this.$validator.validateAll().then((result) => {
        			let data = {}
    				data.producto = vm.input.producto
    				data.proyecto = vm.input.proyecto
    				data.cliente = vm.input.cliente
    				data.descripcion_producto = vm.input.descripcion_producto
    				if (result) {
        				console.log(vm.$store.state.online)
    					if (vm.$store.state.online) {
    						data.id = data._id
    						axios.post(vm.urlAPI, data, {headers: {
    		    		    	Authorization: 'Bearer ' +  vm.token
    			    		 	}
    			    		})
    			    		.then(function (response) {
    			    			data._id = response.data.id
    			    			vm.items.unshift(data)
    			    			vm.clearForm()
    	        				vm.listar()
    			            }).catch(function (error) {
        			           alert('Error: ' + error)
    			            })
    					} else {
    						vm.input._id = Date.now().toString();
							data._id = vm.input._id
							data.asset = vm.tipoItem
    						vm.dbAdd(vm.input, 'add')
    						vm.items.unshift(data)
    						vm.clearForm()
        					vm.listar()
    					}
    				}
    			}).catch(() => {
    		})
    	},
    	cargar (item) {
			this.input._id = item._id
    		this.input.cliente = item.cliente
    		this.input.producto = item.producto
    		this.input.proyecto = item.proyecto
    		this.input.descripcion_producto = item.descripcion_producto
			this.savebtn = false
			this.updatebtn = true
			this.show('form')
		},
    	editar (id) {
			var vm = this
    		this.$validator.validateAll().then((result) => {
				if (result) {
					let data = {}
					data.producto = vm.input.producto
    				data.proyecto = vm.input.proyecto
    				data.cliente = vm.input.cliente
    				data.descripcion_producto = vm.input.descripcion_producto
					if (vm.$store.state.online) {
						axios.put(vm.urlAPI + '/' + vm.input._id, data, {headers: {
		    		    		Authorization: 'Bearer ' +  vm.token
			    		 	}
			    		})
			    		.then(function (response) {
			    			vm.clearForm()
	        				vm.listar()
			            }).catch(function (error) {
    			           alert('Error: ' + error)
			            })
					} else {
						data._id = vm.input._id
						data.asset = vm.tipoItem
						vm.dbAdd(data, 'edit')
						vm.clearForm()
    					vm.listar()
					}
					var index = vm.items.findIndex(item => item._id === vm.input._id)
					data._id = vm.input._id
					vm.items.splice(index, 1, data)
    			}
			}).catch(() => {
			})
    	},
    	remove (item) {
			if (window.confirm('Seguro desea archivar el registro')) {
				let vm = this
				if (vm.$store.state.online) {
					let data = {}
					data.Archivar = true
					axios.put(vm.urlAPI + '/' + item._id, data, {headers: {
	    		    	Authorization: 'Bearer ' +  vm.token
		    		 	}
		    		})
		    		.then(function (response) {
		    			vm.clearForm()
        				vm.listar()
		            }).catch(function (error) {
			           alert('Error: ' + error)
		            })
				} else {
					delete item.__v
					item.asset = vm.tipoItem 
					vm.dbAdd(item, 'delete')
					vm.clearForm()
					vm.listar()
				}

				var index = vm.items.findIndex(itemList => itemList._id === item._id)
				vm.items.splice(index, 1)
				vm.eliminados.push(item)
			}
    	},
    	desarchivar (itemDelete) {
			var vm = this
			let data = {}
			data.Archivar = false
			if (vm.$store.state.online) {
				axios.put(vm.urlAPI + '/' + itemDelete._id, data, {headers: {
    		    		Authorization: 'Bearer ' +  vm.token
	    		 	}
	    		})
	    		.then(function (response) {
		    		var index = vm.eliminados.findIndex(item => item._id === itemDelete._id)
        			console.log(index)
        			itemDelete.Archivar = false
        			vm.eliminados.splice(index, 1)
        			vm.items.unshift(itemDelete)
	            }).catch(function (error) {
		           alert('Error: ' + error)
	            })
			} else {
				alert('Para desarchivar el registro, debe estar online')
			}
		},
    	dbAdd (item, accion) {
			item.accion = accion
			item.asset = this.tipoItem
			db.put(item).then(function(response) {
			}).catch(function(error) {
				console.log(error)
			})
    	},
    	clearForm() {
    		this.input._id = ''
    		this.input.cliente = ''
    		this.input.producto = ''
    		this.input.descripcion_producto = ''
    		this.input.proyecto = ''
        	this.input.accion = ''
    	},
    	listarAPI() {
			let vm = this
			vm.items.length = 0
			vm.items = []
			vm.eliminados.length = 0
			vm.eliminados = []

			vm.$store.commit('CLEAR_PRODUCTOS', null)
    		axios.get(vm.urlAPI + '?_sort=createdAt:desc', {headers: {
    		    	Authorization: 'Bearer ' +  vm.token
    		 	}
    		})
    		.then(function (response) {
    			for (var i = 0; i < response.data.length; i++) {
    				if(response.data[i].Archivar) {
    					vm.eliminados.push(response.data[i])
        			} else {
        				vm.items.push(response.data[i])
        				vm.$store.commit('ADD_PRODUCTO', response.data[i])
					}
    			}
            }).catch(function (error) {
            })
		}
	},
	computed: {
		isMobile () {
        	return (window.innerWidth <= 800 && window.innerHeight <= 600)
		},
		filteredItems()
	    {
	    	var self=this;
	    	return this.items.filter(function(cust){return cust.producto.toLowerCase().indexOf(self.search.toLowerCase())>=0;});
	    },
	    filteredEliminados()
	    {
	    	var self=this;
	    	return this.eliminados.filter(function(cust){return cust.producto.toLowerCase().indexOf(self.search.toLowerCase())>=0;});
	    }
	},
	mounted () {
		this.$nextTick(() => {})
		let vm = this
		vm.items = []
		
		if (vm.$store.state.online) {
			// console.log('no cache')
    		vm.listarAPI()
		} else {
			var productos = vm.$store.state.productos
			for (var i = 0; i < productos.length; i++) {
				if(productos[i].Archivar) {
					vm.eliminados.push(productos[i])
				} else {
					vm.items.push(productos[i])
				}
			}
		}
	},
	created () {
		this.$store.watch(
			(state)=>{
				return this.$store.state.pendientes.productos
			},
			(newValue, oldValue)=>{
				this.listarAPI()
			},
			{
				deep:true
			}
		)
    },
    beforeDestroy() {
        // var productos = this.items.concat(this.eliminados)
        this.$store.commit('CLEAR_PRODUCTOS', null)
        this.$store.commit('SYNC_PRODUCTO', this.items)
    } 
}
</script>
<style>
.info-box {
  cursor: pointer;
}
.info-box-content {
  text-align: center;
  vertical-align: middle;
  display: inherit;
}
.fullCanvas {
  width: 100%;
}
.nav-tabs-custom>.nav-tabs.pull-left {
    float: none !important;
}
.btn-edit {
    max-width: 50px;
    float: left;
} 
.fa-times-circle {
    margin-top: 5px;
    color: crimson;
    font-size: larger;
    margin-left: 20px;
    cursor: pointer;
}
.help-block {
    color: #dd4b39;
}
</style>



// WEBPACK FOOTER //
// Producto.vue?74157d33